import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface Category {
  name: string;
  url: string;
  icon: string;
}

const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-cloud-windy-line' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-5-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-vip-crown-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link-unlink' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

const comparisonLinks = [
  { label: 'Kakobuy Spreadsheet', to: '/kakobuy-spreadsheet' },
  { label: 'CSSBuy Spreadsheet', to: '/cssbuy-spreadsheet' },
  { label: 'Superbuy Spreadsheet', to: '/superbuy-spreadsheet' },
  { label: 'Oopbuy Spreadsheet', to: '/oopbuy-spreadsheet' },
];

export default function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileExpandedSection, setMobileExpandedSection] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const closeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMouseEnter = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
    }, 200);
  };

  const toggleMobileSection = (section: string) => {
    setMobileExpandedSection(mobileExpandedSection === section ? null : section);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center gap-8">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight ${isScrolled ? 'text-foreground-900' : 'text-white'}`}>
                hipobuy<span className="text-primary-500">spread</span>
              </span>
            </Link>
            <div className="hidden md:flex items-center gap-6">
              <div
                ref={dropdownRef}
                className="relative"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <button
                  className={`flex items-center gap-1.5 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                    isScrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/90 hover:text-white'
                  }`}
                >
                  Categories
                  <i className={`ri-arrow-down-s-line transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 rounded-lg border border-background-200/70 py-2 shadow-lg">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-accent-100/50 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {cat.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
              <Link
                to="/what-is-hipobuy-sheet"
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  isScrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/90 hover:text-white'
                }`}
              >
                Guide
              </Link>
              <Link
                to="/kakobuy-spreadsheet"
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  isScrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/90 hover:text-white'
                }`}
              >
                Compare
              </Link>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 rounded-full bg-white/20 text-white text-sm font-semibold hover:bg-white/30 transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              Hipobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-xl ${isScrolled ? 'text-foreground-900' : 'text-white'} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/60 max-h-[70vh] overflow-y-auto">
            <div className="py-4 px-2 space-y-1">
              <div className="flex items-center gap-3 px-4 py-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex-1 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold text-center cursor-pointer whitespace-nowrap"
                >
                  Buy It Now
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex-1 py-3 rounded-full bg-background-200/60 text-foreground-900 text-sm font-semibold text-center cursor-pointer whitespace-nowrap"
                >
                  Hipobuy Sheet
                </a>
              </div>

              <div className="border-t border-background-200/60 pt-3 mt-2">
                <button
                  onClick={() => toggleMobileSection('categories')}
                  className="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold text-foreground-900 cursor-pointer"
                >
                  <span className="flex items-center gap-2">
                    <i className="ri-grid-line text-base"></i>
                    Categories
                  </span>
                  <i className={`ri-arrow-down-s-line transition-transform duration-200 ${mobileExpandedSection === 'categories' ? 'rotate-180' : ''}`}></i>
                </button>
                {mobileExpandedSection === 'categories' && (
                  <div className="grid grid-cols-2 gap-1 px-2 pb-2">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-2 px-3 py-2.5 text-sm text-foreground-600 hover:bg-accent-50/60 hover:text-foreground-900 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className={`${cat.icon} text-foreground-400 text-xs`}></i>
                        <span className="truncate">{cat.name}</span>
                      </a>
                    ))}
                  </div>
                )}
              </div>

              <div className="border-t border-background-200/60 pt-2">
                <button
                  onClick={() => toggleMobileSection('guides')}
                  className="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold text-foreground-900 cursor-pointer"
                >
                  <span className="flex items-center gap-2">
                    <i className="ri-article-line text-base"></i>
                    Platform Guides
                  </span>
                  <i className={`ri-arrow-down-s-line transition-transform duration-200 ${mobileExpandedSection === 'guides' ? 'rotate-180' : ''}`}></i>
                </button>
                {mobileExpandedSection === 'guides' && (
                  <div className="px-2 pb-2 space-y-1">
                    <Link to="/what-is-hipobuy-sheet" className="flex items-center gap-2 px-3 py-2.5 text-sm text-foreground-600 hover:bg-primary-50/60 hover:text-primary-700 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-guide-line text-foreground-400 text-xs"></i>
                      Hipobuy Spreadsheet Guide
                    </Link>
                    {comparisonLinks.map((link) => (
                      <Link key={link.to} to={link.to} className="flex items-center gap-2 px-3 py-2.5 text-sm text-foreground-600 hover:bg-accent-50/60 hover:text-foreground-900 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                        <i className="ri-arrow-right-circle-line text-foreground-400 text-xs"></i>
                        {link.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <div className="border-t border-background-200/60 pt-2 pb-1">
                <Link
                  to="/"
                  className="flex items-center gap-2 px-4 py-3 text-sm text-foreground-600 hover:bg-background-100 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-home-4-line text-base text-foreground-400"></i>
                  Back to Homepage
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}